module.exports = __webpack_public_path__ + "img/avega.a922e1dc.png";